import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopBarComponent } from './top-bar/top-bar.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { MarketplaceHomePageComponent } from './marketplace-home/marketplace-home.component';
import { AppDetailShellComponent } from './app-detail-shell/app-detail-shell.component';
import { FooterComponent } from './footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MarketplaceRouting } from './app-marketplace-feature-app-marketplace-routing.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { AppNotFoundComponent } from './app-not-found/app-not-found.component';
import { MatRippleModule } from '@angular/material/core';
import { HubspotDemoDialogComponent } from './dialogs/hubspot-demo-dialog/hubspot-demo-dialog.component';
import { HubspotSubscribeDialogComponent } from './dialogs/hubspot-subscribe-dialog/hubspot-subscribe-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MarketplaceSharedModule } from '@realwear-cloud/app-marketplace/shared';
import { ComponentsModule } from '@realwear-cloud/shared/ui-kit';
import { PopupNotificationModule } from '@realwear-cloud/shared/ui-kit';
import { HubspotSubmitterService } from './dialogs/hubspot-subscribe-dialog/hubspot-submitter.service';
import { AlexandriaModule } from '@realwear-cloud/alexandria';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    MatIconModule,
    FontAwesomeModule,
    MarketplaceRouting,
    MatDividerModule,
    MatFormFieldModule,
    MatRippleModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MatCheckboxModule,
    MarketplaceSharedModule,
    MatButtonModule,
    PopupNotificationModule.forRoot(),
    MatButtonModule,
    ComponentsModule,
    AlexandriaModule
  ],
  declarations: [
    TopBarComponent,
    HeaderComponent,
    AppNotFoundComponent,
    MarketplaceHomePageComponent,
    AppDetailShellComponent,
    HubspotDemoDialogComponent,
    HubspotSubscribeDialogComponent,

    FooterComponent
  ],
  providers: [HubspotSubmitterService],
  exports: [MarketplaceHomePageComponent]
})
export class AppMarketplaceFeatureAppMarketplaceModule {}
